export default "__VITE_PUBLIC_ASSET__662bc610__"